import moment from 'moment'
import pdf from '@/services/pdf'
import upload from '@/services/upload'

async function create(productItem, productType, vimeo) {
  productItem.keywords = productItem.keywords.map(keyword => keyword.keyword)
  productItem.authors = productItem.authors.map(author => author.id)

  if (productItem.content) {
    productItem.content = await uploadContentHandler(
      productType,
      productItem,
      vimeo,
    )
  }

  productItem.publishDate = handlePublishDate(productItem.publishDate)

  return productItem
}

function handlePublishDate(publishDate) {
  return publishDate
    ? moment(publishDate)
        .utc()
        .format('YYYY-MM-DD')
    : null
}

async function update(productItem, productType, vimeo) {
  productItem.keywords = productItem.keywords.map(keyword => keyword.keyword)
  productItem.authors = productItem.authors.map(author => author.id)

  const uploadNewContent = typeof productItem.content !== 'string'
  if (uploadNewContent && productItem.content) {
    productItem.content = await uploadContentHandler(
      productType,
      productItem,
      vimeo,
    )
  }

  productItem.publishDate = handlePublishDate(productItem.publishDate)

  return productItem
}

async function uploadContentHandler(productType, productItem, vimeo) {
  if (productItem.content.type.includes('video')) {
    productItem.fileFormat = null

    if (vimeo) {
      productItem.content = await vimeo.uploadVideo(productItem.content, {
        name: productItem.title,
      })

      if (productItem.cover) {
        await vimeo.uploadThumbnail(productItem.content, productItem.cover)
      }
    } else {
      productItem.content = null
    }
  } else {
    if (productItem.fileFormat === 'pdf') {
      const firstPage = Number(productItem.initialPage)
      const lastPage = Number(productItem.length) + firstPage - 1

      if (productItem.initialPage) {
        productItem.content = await pdf.extractPagesFromPdf(
          productItem.content,
          firstPage,
          lastPage,
        )
      }

      const { data } = await upload.send(productItem.content)
      productItem.content = data.url
    }
  }

  return productItem.content
}

export default {
  create,
  update,
}
